import { find } from "rxjs";
import { Injectable } from "@angular/core";
import { Plugins } from "@capacitor/core";
import { EncriptadorService } from "./encriptador.service";

const { Storage } = Plugins;

@Injectable({
  providedIn: "root",
})
export class StorageService {
  AskItems: number;

  constructor(private encryption: EncriptadorService) {}

  async storage(storageKey: string, value: any) {
    //const encryptedValue = btoa(escape(JSON.stringify(value)));
    const encryptedValue = btoa(
      escape(this.encryption.encrypt(JSON.stringify(value)))
    );
    await Storage.set({
      key: storageKey,
      value: encryptedValue,
    });
  }

  async get(storageKey: string) {
    const res = await Storage.get({ key: storageKey });
    if (res.value) {
      //return JSON.parse(unescape(atob(res.value)));
      return JSON.parse(this.encryption.decrypt(unescape(atob(res.value))));
    } else {
      return false;
    }
  }

  async setTimerExercice(
    storageKey: string,
    id,
    idActividad,
    timer,
    globalTime
  ) {
    const res = await Storage.get({ key: storageKey });
    if (res.value) {
      const data = JSON.parse(
        this.encryption.decrypt(unescape(atob(res.value)))
      );
      data.forEach((item) => {
        if (item.id_actividad === idActividad) {
          item.globalTime = globalTime;
          item.data.forEach((element) => {
            if (element.id === id) {
              element.time = timer;
            }
          });
        }
      });
      const encryptedValue = btoa(
        escape(this.encryption.encrypt(JSON.stringify(data)))
      );
      await Storage.set({
        key: storageKey,
        value: encryptedValue,
      });
      console.log("🚀 ~ StorageService ~ setTimerExercice ~ data:", data);
    }
  }

  async removeItem(storageKey: string) {
    await Storage.remove({ key: storageKey });
  }
  async clear() {
    await Storage.clear();
  }
}
